import Swiper from "swiper";
import { Navigation, Pagination, Thumbs, Autoplay } from "swiper/modules";

Swiper.use([Navigation, Pagination, Thumbs, Autoplay]);

(function () {
  document.addEventListener("DOMContentLoaded", () => {
    const swipers = document.querySelectorAll("[data-swiper]") || [];
    if (swipers) {
      swipers.forEach((elem) => {
        let options =
          elem.dataset && elem.dataset.options
            ? JSON.parse(elem.dataset.options)
            : {};
        console.log("otp", options);

        if (options.thumbs) {
          const thumbsElem = document.querySelector(options.thumbs);
          if (thumbsElem) {
            options.thumbs = {
              swiper: new Swiper(thumbsElem, {}),
            };
          }
        }
        var swiper = new Swiper(elem, options);
      });
    }
  });
})();
